import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpParams} from '@angular/common/http';


export interface EmployeeRequestParam {
    id: number;
    name: string;
    contact: string;
    email: string;
    username: string;
    password: string;
    statusId: number;
    status: string;

}

@Injectable()
export class EmployeeService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }




}
